module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-pickwick-bottom-01.1.a45bf164.jpg";